import states from "@/data/states"

export default {
    findStates() {
        return Promise.resolve({
            states,
        })
    },
}
